import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach admin token automatically if present.
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("p2p_admin_token");
  if (t && config.url && config.url.startsWith("/admin")) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  }
  return config;
});

// On 401 from any /admin/* call, clear the token and bump to the sign-in
// screen with an "expired" notice. Skips during /admin/login itself.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    const status = err?.response?.status;
    if (status === 401 && url.startsWith("/admin") && !url.includes("/admin/login") && !url.includes("/admin/setup")) {
      clearAdminToken();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
        window.location.replace("/admin/login?expired=1");
      }
    }
    return Promise.reject(err);
  },
);

export const getAdminToken = () => localStorage.getItem("p2p_admin_token");
export const setAdminToken = (t) => localStorage.setItem("p2p_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("p2p_admin_token");

export const getReturnToken = () => localStorage.getItem("p2p_return_token");
export const setReturnToken = (t) => localStorage.setItem("p2p_return_token", t);
export const clearReturnToken = () => localStorage.removeItem("p2p_return_token");

// Refresh the admin token to extend the rolling session window. Called by
// AdminLayout on activity. Failures bubble to the response interceptor.
export const refreshAdminSession = async () => {
  const { data } = await api.post("/admin/refresh");
  setAdminToken(data.token);
  return data;
};
